// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDSF0ijOI0PGUgBQOoidiMEl2VFw4fyWY0",
  authDomain: "acm-w-f5d70.firebaseapp.com",
  projectId: "acm-w-f5d70",
  storageBucket: "acm-w-f5d70.firebasestorage.app",
  messagingSenderId: "937922405462",
  appId: "1:937922405462:web:b5c01e38b0db54901b47f7",
  measurementId: "G-1LGZWK3ZFT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Firestore Database instance
const db = getFirestore(app);
export { db };